/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { pointControllerSearchCursorPointLogs } from '../fn/point/point-controller-search-cursor-point-logs';
import { PointControllerSearchCursorPointLogs$Params } from '../fn/point/point-controller-search-cursor-point-logs';

@Injectable({ providedIn: 'root' })
export class PointService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pointControllerSearchCursorPointLogs()` */
  static readonly PointControllerSearchCursorPointLogsPath = '/api/point/log/cursor';

  /**
   * 포인트 로그를 커서 기반으로 검색합니다.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pointControllerSearchCursorPointLogs()` instead.
   *
   * This method doesn't expect any request body.
   */
  pointControllerSearchCursorPointLogs$Response(params: PointControllerSearchCursorPointLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return pointControllerSearchCursorPointLogs(this.http, this.rootUrl, params, context);
  }

  /**
   * 포인트 로그를 커서 기반으로 검색합니다.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pointControllerSearchCursorPointLogs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pointControllerSearchCursorPointLogs(params: PointControllerSearchCursorPointLogs$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.pointControllerSearchCursorPointLogs$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

}
